import { Card as AntCard, CardProps } from "antd";

const Card = (props: CardProps) => <AntCard bordered={false} {...props} />;

export default Card;
